module.exports = __webpack_public_path__ + "static/promo-text-c3c679fa4742cd68e45c3f7f8e73d871.svg";